import script from "./UserDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDashboard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__